export const animationData = {
  nm: 'Main Scene',
  ddd: 0,
  h: 40,
  w: 190,
  meta: {
    g: '@lottiefiles/creator 1.46.1',
  },
  layers: [
    {
      ty: 4,
      nm: '32 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 11,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 21,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 26,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 31,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 36,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 41,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 46,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 51,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 61,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 66,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 71,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 76,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 81,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 86,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [78.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 1,
    },
    {
      ty: 4,
      nm: '32 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 11,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 21,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 26,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 31,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 36,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 41,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 46,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 51,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 61,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 66,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 71,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 76,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 81,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 86,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [78.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 2,
    },
    {
      ty: 4,
      nm: '31 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 17,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 82,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.501, 1],
                    [0.501, 1],
                    [0.501, -1],
                    [-0.501, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [76.501, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 3,
    },
    {
      ty: 4,
      nm: '31 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 17,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 82,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.501, 1],
                    [0.501, 1],
                    [0.501, -1],
                    [-0.501, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [76.501, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 4,
    },
    {
      ty: 4,
      nm: '30 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 85,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 95.0000038694293,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [74.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 5,
    },
    {
      ty: 4,
      nm: '30 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 85,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 95.0000038694293,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [74.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 6,
    },
    {
      ty: 4,
      nm: '29 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [72.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 7,
    },
    {
      ty: 4,
      nm: '29 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [72.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 8,
    },
    {
      ty: 4,
      nm: '28 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 93.0000037879676,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [70.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 9,
    },
    {
      ty: 4,
      nm: '28 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 93.0000037879676,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [70.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 10,
    },
    {
      ty: 4,
      nm: '27 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 52,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 82,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 87,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 92,
            },
            {
              s: [100, 100, 100],
              t: 97.000003950891,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [68.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 11,
    },
    {
      ty: 4,
      nm: '27 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 52,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 82,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 87,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 92,
            },
            {
              s: [100, 100, 100],
              t: 97.000003950891,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [68.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 12,
    },
    {
      ty: 4,
      nm: '26 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 75,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [66.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 13,
    },
    {
      ty: 4,
      nm: '26 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 75,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [66.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 14,
    },
    {
      ty: 4,
      nm: '25 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 17,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 82,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [64.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 15,
    },
    {
      ty: 4,
      nm: '25 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 17,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 82,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [64.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 16,
    },
    {
      ty: 4,
      nm: '24 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 78,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [62.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 17,
    },
    {
      ty: 4,
      nm: '24 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 78,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [62.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 18,
    },
    {
      ty: 4,
      nm: '23 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 85,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 95.0000038694293,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [60.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 19,
    },
    {
      ty: 4,
      nm: '23 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 85,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 95.0000038694293,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [60.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 20,
    },
    {
      ty: 4,
      nm: '22 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.501, 1],
                    [0.501, 1],
                    [0.501, -1],
                    [-0.501, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [58.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 21,
    },
    {
      ty: 4,
      nm: '22 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.501, 1],
                    [0.501, 1],
                    [0.501, -1],
                    [-0.501, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [58.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 22,
    },
    {
      ty: 4,
      nm: '21 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 93,
            },
            {
              s: [100, 100, 100],
              t: 98.0000039916218,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [56.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 23,
    },
    {
      ty: 4,
      nm: '21 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 93,
            },
            {
              s: [100, 100, 100],
              t: 98.0000039916218,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [56.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 24,
    },
    {
      ty: 4,
      nm: '20 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 17,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 52,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 77,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [54.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 25,
    },
    {
      ty: 4,
      nm: '20 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 17,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 52,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 77,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [54.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 26,
    },
    {
      ty: 4,
      nm: '19 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -11,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -6,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 14,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 19,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 24,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 29,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 34,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 39,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 44,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 54,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 59,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 64,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 69,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 74,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 79,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [52.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 27,
    },
    {
      ty: 4,
      nm: '19 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -11,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -6,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 14,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 19,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 24,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 29,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 34,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 39,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 44,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 54,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 59,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 64,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 69,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 74,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 79,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [52.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 28,
    },
    {
      ty: 4,
      nm: '18 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 9,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 19,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 29,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 34,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 39,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 44,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 49,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 54,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 59,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 69,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 74,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 79,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 84,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 94.0000038286985,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [50.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 29,
    },
    {
      ty: 4,
      nm: '18 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 9,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 19,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 29,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 34,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 39,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 44,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 49,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 54,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 59,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 69,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 74,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 79,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 84,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 94.0000038286985,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [50.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 30,
    },
    {
      ty: 4,
      nm: '17 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 52,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 82,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 87,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [48.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 31,
    },
    {
      ty: 4,
      nm: '17 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 52,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 82,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 87,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [48.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 32,
    },
    {
      ty: 4,
      nm: '16 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -11,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -6,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 14,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 19,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 24,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 29,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 34,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 39,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 44,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 54,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 59,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 64,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 69,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 74,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 79,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [46.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 33,
    },
    {
      ty: 4,
      nm: '16 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -11,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -6,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 4,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 14,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 19,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 24,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 29,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 34,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 39,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 44,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 54,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 59,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 64,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 69,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 74,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 79,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [46.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 34,
    },
    {
      ty: 4,
      nm: '15 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 93,
            },
            {
              s: [100, 100, 100],
              t: 98.0000039916218,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [44.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 35,
    },
    {
      ty: 4,
      nm: '15 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 93,
            },
            {
              s: [100, 100, 100],
              t: 98.0000039916218,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [44.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 36,
    },
    {
      ty: 4,
      nm: '14 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 75,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [42.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 37,
    },
    {
      ty: 4,
      nm: '14 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 75,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [42.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 38,
    },
    {
      ty: 4,
      nm: '13 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 85,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.501, 1],
                    [0.501, 1],
                    [0.501, -1],
                    [-0.501, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [40.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 39,
    },
    {
      ty: 4,
      nm: '13 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 85,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.501, 1],
                    [0.501, 1],
                    [0.501, -1],
                    [-0.501, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [40.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 40,
    },
    {
      ty: 4,
      nm: '12 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 93,
            },
            {
              s: [100, 100, 100],
              t: 98.0000039916218,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [38.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 41,
    },
    {
      ty: 4,
      nm: '12 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 93,
            },
            {
              s: [100, 100, 100],
              t: 98.0000039916218,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [38.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 42,
    },
    {
      ty: 4,
      nm: '11 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 85,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [36.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 43,
    },
    {
      ty: 4,
      nm: '11 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 85,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [36.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 44,
    },
    {
      ty: 4,
      nm: '10 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 85,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 95.0000038694293,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [34.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 45,
    },
    {
      ty: 4,
      nm: '10 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 85,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 95.0000038694293,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [34.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 46,
    },
    {
      ty: 4,
      nm: '9 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 85,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [32.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 47,
    },
    {
      ty: 4,
      nm: '9 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 85,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [32.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 48,
    },
    {
      ty: 4,
      nm: '8 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 93,
            },
            {
              s: [100, 100, 100],
              t: 98.0000039916218,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [30.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 49,
    },
    {
      ty: 4,
      nm: '8 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 88,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 93,
            },
            {
              s: [100, 100, 100],
              t: 98.0000039916218,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [30.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 50,
    },
    {
      ty: 4,
      nm: '7 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [28.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 51,
    },
    {
      ty: 4,
      nm: '7 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 18,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 58,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 83,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [28.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 52,
    },
    {
      ty: 4,
      nm: '6 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 88,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [26.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 53,
    },
    {
      ty: 4,
      nm: '6 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 13,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 23,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 28,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 33,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 38,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 43,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 48,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 53,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 63,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 68,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 73,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 78,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 83,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 88,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [26.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 54,
    },
    {
      ty: 4,
      nm: '5 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 9,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 14,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 24,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 34,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 39,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 44,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 49,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 54,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 59,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 64,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 74,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 79,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 84,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 94,
            },
            {
              s: [100, 100, 100],
              t: 99.0000040323527,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [24.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 55,
    },
    {
      ty: 4,
      nm: '5 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 9,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 14,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 24,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 34,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 39,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 44,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 49,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 54,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 59,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 64,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 74,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 79,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 84,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 94,
            },
            {
              s: [100, 100, 100],
              t: 99.0000040323527,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [24.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 56,
    },
    {
      ty: 4,
      nm: '4 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 52,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 82,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 87,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.501, 1],
                    [0.501, 1],
                    [0.501, -1],
                    [-0.501, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [22.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 57,
    },
    {
      ty: 4,
      nm: '4 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 2,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 12,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 52,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 82,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 87,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.501, 1],
                    [0.501, 1],
                    [0.501, -1],
                    [-0.501, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [22.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 58,
    },
    {
      ty: 4,
      nm: '3 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 17,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 82,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [20.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 59,
    },
    {
      ty: 4,
      nm: '3 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: -8,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: -3,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 7,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 17,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 22,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 27,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 32,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 37,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 42,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 47,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 57,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 62,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 67,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 72,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 77,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 82,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [20.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 60,
    },
    {
      ty: 4,
      nm: '2 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 85,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 95.0000038694293,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [18.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 61,
    },
    {
      ty: 4,
      nm: '2 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 10,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 20,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 60,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 85,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 90,
            },
            {
              s: [100, 100, 100],
              t: 95.0000038694293,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [18.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 62,
    },
    {
      ty: 4,
      nm: '1 Outlines 1',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 85,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [131, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [16.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 63,
    },
    {
      ty: 4,
      nm: '1 Outlines',
      sr: 1,
      st: 0,
      op: 90.0000036657751,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 0,
          k: [47.5, 20, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 0,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 5,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 750, 100],
              t: 15,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 150, 100],
              t: 25,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 200, 100],
              t: 30,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 35,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 40,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 45,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 600, 100],
              t: 50,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 800, 100],
              t: 55,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 300, 100],
              t: 65,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 400, 100],
              t: 70,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 100, 100],
              t: 75,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 500, 100],
              t: 80,
            },
            {
              o: {
                x: 0.167,
                y: 0.167,
              },
              i: {
                x: 0.833,
                y: 0.833,
              },
              s: [100, 700, 100],
              t: 85,
            },
            {
              s: [100, 100, 100],
              t: 90.0000036657751,
            },
          ],
          ix: 6,
        },
        sk: {
          a: 0,
          k: 0,
        },
        p: {
          a: 0,
          k: [67, 20],
          ix: 2,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        sa: {
          a: 0,
          k: 0,
        },
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
      },
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Group 1',
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-0.5, 1],
                    [0.5, 1],
                    [0.5, -1],
                    [-0.5, -1],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              c: {
                a: 0,
                k: [0.8078431373, 0.7450980392, 0.9843137255],
                ix: 4,
              },
              r: 1,
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
            },
            {
              ty: 'tr',
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              p: {
                a: 0,
                k: [16.5, 20],
                ix: 2,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
            },
          ],
        },
      ],
      ind: 64,
    },
  ],
  v: '5.7.0',
  fr: 29.9700012207031,
  op: 91,
  ip: 0,
  assets: [],
}
